import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   static outlets = [ "modal" ]

   show() {
      this.modalOutlets.forEach(modal => {
         modal.show();
      });
   }
}
